// extracted by mini-css-extract-plugin
export default {"toggle":"toggle_toggle__VZpJg","switch-part":"toggle_switch-part__cByRr","label-part":"toggle_label-part__7cxDc"};